import { validateUserConnectLicenseMagento } from "../../../../common/constants/shop-api";
import environment from "../../../../common/environment";
import { getResponseData } from "../../../../common/utils/api-utils";

export async function validateUserConnectLicenseMagentoApiCall(isbn: string, token: string) {
  const url = new URL(environment().magentoUrl + validateUserConnectLicenseMagento(isbn));
    
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
      },
    })
  );
}